module.exports = __webpack_public_path__ + "static/media/jaybird-tarah-pro.506ac26d.jpg";